module.exports = __webpack_public_path__ + "img/virtual-gallery.e4e1ff40.png";